import { apiService } from "../constants/ApiService";

// ================== VENDER MASTER  =================
export const fetchVendorMasterAPI = async () => {
    const response = await apiService.get('/api/VenderMaster/all?pageNo=1&limit=100000');
    return response;
};

// ================== BRANCH MASTER  =================
export const fetchBranchMasterAPI = async (vendorId) => {
  let apiUrl = "/api/BranchMaster/all?pageNo=1&limit=100000";

  if (vendorId) {
    apiUrl += `&filterName=${vendorId}`;
  }

  const response = await apiService.get(apiUrl);
  return response;
};
